export default __webpack_public_path__ + "static/media/james-brown.e50f7334.jpg";